// extracted by mini-css-extract-plugin
export default {"container":"simon_container__3P9S2","inner":"simon_inner__2D7c0","image":"simon_image__26X4v","icon":"simon_icon__1imv9","down":"simon_down__1--Oi"};